module.exports = __webpack_public_path__ + "img/home_menu_10_selected.7c9688e5.png";